export default "__VITE_ASSET__40239766__"